export default __webpack_public_path__ + "static/media/Cassete-type-air-conditioning.4098dd11.jpg";